module.exports = __webpack_public_path__ + "img/50.75877095.png";